import React from 'react';

import { mountCss, requireCdnJS } from '../utils/mountSome';
import { isStyleLink } from '../utils/loadcss';
import { IComponent } from './type';

export const BaseErrorComponent: React.FC = () => null;
/**
 * 组件注册类
 * @author zhushitao@bytedance.com
 * @date 2021-03-11
 */
export default class Libraray {
  public libMap = new Map();

  private assertRemoteComponent(config: IComponent) {
    const { component } = config;

    if (typeof component === 'object' && typeof component.js === 'string') {
      return true;
    }
    throw new Error(`load lib type error: ${JSON.stringify(config)}`);
  }
  private async installRemoteComponent(
    cdn: { js: string; css: string },
    moduleName: string,
  ) {
    try {
      const [module] = await Promise.all([
        requireCdnJS({
          moduleName,
          url: cdn.js,
        }),
        isStyleLink(cdn?.css) && mountCss(cdn.css),
      ]);
      return module;
    } catch (error) {
      throw error;
    }
  }

  public registerComponent(
    componentName: string,
    component: React.ReactElement | Promise<React.ReactElement>,
  ): void {
    this.libMap.set(componentName, component);
  }

  public clearComponent(componentName: string): void {
    if (this.libMap.delete) {
      this.libMap.delete(componentName);
    }
  }

  public async getComponent(
    componentConfig: IComponent,
  ): Promise<React.Component | React.FC> {
    const { version, code } = componentConfig;
    const componentKeys = [code];
    if (version) {
      componentKeys.push(version);
    }
    const componentName = componentKeys.join('_');
    let result: Promise<any> | React.ReactElement;
    const CacheComponent = this.libMap.get(componentName);

    if (CacheComponent) {
      result = CacheComponent || BaseErrorComponent;
      return componentConfig.isRemote ? await result : result;
    }

    if (componentConfig.isRemote) {
      try {
        this.assertRemoteComponent(componentConfig);
        result = this.installRemoteComponent(
          componentConfig.component,
          componentName,
        );
        this.registerComponent(componentName, result);
        return await result;
      } catch (error: any) {
        this.clearComponent(componentName);
        return BaseErrorComponent;
      }
    } else {
      this.registerComponent(componentName, componentConfig.component);
      return componentConfig.component || BaseErrorComponent;
    }
  }
}
